(function() {
angular.module('menu')
  .component('menuRight', {
    templateUrl: 'js/custom-components/menu-right/menu-right.component.html',
    bindings: {
      agenda: "=",
      tableData: "=",
      /*eventSources: "=",*/
      onListOpenAvisoDetail: "&"
    },
    controller: 'MenuRightController',
    controllerAs: 'ctrl'
  });

})();
